import API from "../../helpers/API";
import {
  SET_CAPTCHA_IMAGE,
  LOGOUT_CLEAR_USER_SESSION,
  SET_GET_EMAIL_OTP_RESPONSE,
  SET_GET_MOBILE_OTP_RESPONSE,
  SET_VERIFY_OTP_FLAG_LOGIN,
  SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
  SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
  GET_OTP_TIMER_EMAIL,
  GET_OTP_TIMER_MOBILE,
  SET_ALL_ADVERTISEMENTS,
  SET_MASTER_TYPES,
  SET_ALL_TYPES,
  SET_ALL_USER_ROLES,
  SET_ALL_USERS_BY_ROLE_ID_FROM,
  SET_ALL_USERS_BY_ROLE_ID_TO,
  SET_ALL_MODULES,
  SET_ALL_SUB_MODULES_BY_MODULE_ID,
  SET_ASSIGN_SUBMODULES_BY_USER_MODULE_ID,
  SET_TRANSACTIONAL_DATA_TYPES,
  SET_YEAR_BY_ID,
  SET_YEAR,
  SET_ALPHABETICAL_LIST,
  GET_FLAG_ACCESS_STATUS,
  GET_QUALIFICATIONTYPE,
  GET_QUALIFICATION_NAME_BYTYPE,
  GET_DESIGNATION,
  GET_JOB_NATURE,
  GET_APPOINTMENT_NATURE,
  SET_MAINS_ADVERTISEMENT,
  SET_PRE_ADVERTISEMENT,
  GET_INTERVIEW_CRITERIA_DATA_VIEW,
  SET_USER_DEPT_ROLES,
  SET_USER_DEPT_ROLES_FROM,
  GET_RECOMMENDATION_CRITERIA_DATA_VIEW,
  SET_MODULE_SUBMODULE,
  SET_UPDATE_USER_DATA_ID,
  SET_FILE_UPLOAD_STATUS,
  SAVE_RESULT_FLOW_SUCCESS,
  SAVE_RESULT_FLOW_FAILURE,
  SAVE_RESULT_FLOW_REQUEST,
  SET_POST_CRITERIA_LIST,
  SET_POST_CRITERIA,
  SET_SUBJECT_LIST_POST,
  SET_RESULT_FLOW_INFO,
  SET_LOOKUP_OPTIONS_EXAM_TYPE,
  SET_CHECK_QUALIFIED_LIST,
  SET_FINAL_RESULT_LIST,
  SET_CUTOFF_SUMMARY,
  SET_RESULT_FLOW_ADVERTISEMENT_LIST,
  SET_RESULT_FLOW_YEAR_LIST,
  GET_EXAM_NAME,
  GET_POST_CRITERIA_LIST
} from "../../common/constants/ActionTypes";
import {
  OTPS,
  LOGOUT,
  VERIFYOTP,
  ADMINOTPS,
  GETADVERTISEMENT,
  UPLOADPOSTDATA,
  UPLOADEXAMDATA,
  UPLOADADVERTISEMENTDATA,
  UPLOADMASTERDATA,
  GETMASTERTYPES,
  GETALLTYPES,
  GET_ALL_USER_ROLES,
  GET_ALL_USERS_BY_ROLE_ID,
  GET_ALL_MODULES,
  GET_ALL_SUB_MODULES_BY_MODULE_ID,
  MANAGE_ACCESS_TO_USER,
  GET_ASSIGN_SUB_MODULES_BY_USER_MODULE_ID,
  GETTRANSACTIOANALTYPES,
  GETADVERTISEMENTBYEAR,
  GETYEARLIST,
  GET_ALPHABETICAL_LIST,
  DOWNLOAD_SAMPLE_FILE,
  FLAG_ACCESS_STATUS,
  SET_INTERVIEW_RECOMMENDATION,
  GET_QUALIFICATION_TYPE,
  GET_QUALIFICATION_NAME_BY_TYPE,
  GET_EXPERIENCE,
  SET_RECOMMENDATION_CRITERIA,
  GET_INTERVIEW_CRITERIA_DATA,
  GET_USER_DEPT_ROLES,
  SET_UPDATE_INTERVIEW_CRITERIA,
  GET_RECOMMENDATION_CRITERIA_DATA,
  SET_UPDATE_RECOMMENDATION_CRITERIA,
  GET_MODULE_SUBMODULE,
  GET_USER_UPDATE_ID,
  START_FILE_UPLOAD,
  FILE_UPLOAD_STATUS,
  DOWNLOAD_ERROR_FILE,
  UPLOAD_TRANSACTIONAL_ANSWER_KEY_DATA,
  SAVE_RESULT_FLOW,
  FETCH_SUBJECTS_BY_EXAM_AND_POST,
  SET_POST_LIST,
  GET_SAVE_INFO,
  EXAM_TYPE_LOOKUPOPTION,
  GET_CHECK_QUALIFIED_LIST,
  GET_FINAL_RESULT_LIST,
  GET_CUTOFF_SUMMARY,
  EXAM_NAME
} from "../../common/constants/endpoints";
import label from "../labels/common_en.json";
import { toastr } from "react-redux-toastr";
import FileDownload from "js-file-download";
import { printrecommendationReport } from "../../administration/actions/administrationActions";
import moment from "moment";

export const displayToastrMessage = (type, message) => {
  switch (type) {
    case 'success':
      toastr.success(message);
      break;
    case 'error':
      toastr.error(message);
      break;
    case 'warning':
      toastr.warning(message);
      break;
    default:
      // toastr.info('Info', message || 'No specific message type was provided.');
      break;
  }
};

export const handleError = (error) => {
  if (error && error.response) {
    let errorMessage =
      error && error.response && error.response.data
        ? error.response.data.message
        : error.message;
    toastr.error(errorMessage);
    return;
  }
};

export const handleResponseMessage = (response) => {
  if (response && response.data) {
    let messageType = response.data.messageType;
    let message = response.data.message;

    displayToastrMessage(messageType, message);
  }
};

export const uploadAdvertisementPostExam = (
  type,
  data,
  setSelectedType,
  date
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", type);
    if (date) {
      formData.append("updateDataFrom", date);
    }
  }

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      let apiendpoint = "";
      if (type === "exam") {
        apiendpoint = UPLOADEXAMDATA;
      } else if (type === "advertisement") {
        apiendpoint = UPLOADADVERTISEMENTDATA;
      } else {
        apiendpoint = UPLOADPOSTDATA;
      }
      if (apiendpoint) {
        response = await API.post(apiendpoint, formData, {
          headers: header,
        });
      }
      setSelectedType("");

      if (response.data !== "") {
        const lines = response.data.split("\n");
        const count = parseInt(lines[0].split(":")[1].trim());

        if (lines.length > 3) {
          const successMessage =
            count === 0
              ? "No records added. Some errors in csv. Please check the downloaded file."
              : `${count} records have been added successfully. Some errors in csv. Please check the downloaded file.`;

          toastr.success(successMessage);

          const errorCsvContent = lines.slice(3).join("\n");
          FileDownload(errorCsvContent, `Data_${type}.csv`);
        } else {
          const successMessage =
            count === 0
              ? "No records added"
              : `${count} records have been added successfully`;

          toastr.success(successMessage);
        }
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const uploadDataByUsingCron = (data, date, handleClearFile) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.csvUploadConfigId) {
    formData.append("file", data.file);
    formData.append("csvUploadConfigId", data.csvUploadConfigId);
    if (date) {
      formData.append("updateDataFrom", date);
    }
  }

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      response = await API.post(START_FILE_UPLOAD, formData, {
        headers: header,
      });
      handleClearFile();

      if (response.data !== "") {
        const lines = response.data.split("\n");
        const count = parseInt(lines[0].split(":")[1].trim());

        if (lines.length > 3) {
          const successMessage =
            count === 0
              ? "No records added. Some errors in csv. Please check the downloaded file."
              : `${count} records have been added successfully. Some errors in csv. Please check the downloaded file.`;

          toastr.success(successMessage);

          const errorCsvContent = lines.slice(3).join("\n");
          FileDownload(errorCsvContent, `TransactionalData.csv`);
        } else {
          const successMessage =
            count === 0
              ? "No records added"
              : `${count} records have been added successfully`;

          toastr.success(successMessage);
        }
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const uploadTransactionalData = (
  type,
  data,
  setSelectedType,
  date,
  handleClearFile
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const token = session?.jwtResponse?.token;

  const formData = new FormData();

  if (data?.file) {
    formData.append("file", data.file);
    formData.append("type", type);

    if (date) {
      formData.append("updateDataFrom", date);
    }
  }

  const header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  };

  return async (dispatch) => {
    try {
      const response = await API.post(UPLOADMASTERDATA, formData, {
        headers: header,
      });
      if (
        response?.data &&
        typeof response.data === "string" &&
        response.data.trim() !== ""
      ) {
        // Remove empty lines
        const lines = response.data
          .split("\n")
          .filter((line) => line.trim() !== "");

        // Extract count safely
        const count =
          parseInt(lines[0]?.split(":")[1]?.trim(), 10) || 0;

        // Error CSV exists after first line
        const hasErrorCsv = lines.length > 1;

        if (hasErrorCsv) {
          const successMessage =
            count === 0
              ? "No records added. Some errors in csv. Please check the downloaded file."
              : `${count} records have been added successfully. Some errors in csv. Please check the downloaded file.`;

          toastr.success(successMessage);

          // Skip count line and create CSV
          const errorCsvContent = lines.slice(1).join("\n");

          FileDownload(errorCsvContent, `Data_${type}.csv`);
        } else {
          const successMessage =
            count === 0
              ? "No records added"
              : `${count} records have been added successfully`;

          toastr.success(successMessage);
        }

        handleClearFile();
      } else {
        toastr.error("Invalid response from server");
      }
    } catch (error) {
      console.log("UPLOAD ERROR =>", error);
      handleError(error);
    }
  };
};
export const uploadTransactionalAnswerKeyData = (type, data, setSelectedType, date, examId, subjectId, advertisementId, handleClearFile,) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", type);
    formData.append("examId", examId);
    formData.append("subjectId", subjectId);
    formData.append("id", advertisementId);
    if (date) {
      formData.append("updateDataFrom", date);
    }
  }
  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      // response = await API.post(UPLOAD_TRANSACTIONAL_ANSWER_KEY_DATA, formData, {
      response = await API.post(UPLOADMASTERDATA, formData, {
        headers: header,
      });
      handleClearFile();

      if (response.data !== "") {
        const lines = response.data.split("\n");
        const count = parseInt(lines[0].split(":")[1].trim());

        if (lines.length > 3) {
          const successMessage =
            count === 0
              ? "No records added. Some errors in csv. Please check the downloaded file."
              : `${count} records have been added successfully. Some errors in csv. Please check the downloaded file.`;

          toastr.success(successMessage);

          const errorCsvContent = lines.slice(3).join("\n");
          FileDownload(errorCsvContent, `Data_${type}.csv`);
        } else {
          const successMessage =
            count === 0
              ? "No records added"
              : `${count} records have been added successfully`;

          toastr.success(successMessage);
        }
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const uploadMastersData = (type, data, setSelectedType, date) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", type);
    if (date) {
      formData.append("updateDataFrom", date);
    }
  }

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      let apiendpoint = "";
      // if (
      //   type === "examSubject" ||
      //   type === "category" ||
      //   type === "subCategory" ||
      //   type === "examCenter" ||
      //   type === "postCriteria" ||
      //   type === "venue" ||
      //   type === "venueCapacity" ||
      //   type === "venueCoordinator"
      // ) {
      //   apiendpoint = UPLOADEXAMDATA;
      // } else {
      apiendpoint = UPLOADMASTERDATA;
      // }
      if (apiendpoint) {
        response = await API.post(apiendpoint, formData, {
          headers: header,
        });
      }
      setSelectedType("");

      if (response.data !== "") {
        const lines = response.data.split("\n");
        const count = parseInt(lines[0].split(":")[1].trim());

        if (lines.length > 3) {
          const successMessage =
            count === 0
              ? "No records added. Some errors in csv. Please check the downloaded file."
              : `${count} records have been added successfully. Some errors in csv. Please check the downloaded file.`;

          toastr.success(successMessage);

          const errorCsvContent = lines.slice(3).join("\n");
          FileDownload(errorCsvContent, `MasterData_${type}.csv`);
        } else {
          const successMessage =
            count === 0
              ? "No records added"
              : `${count} records have been added successfully`;

          toastr.success(successMessage);
        }
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const getAllMasterTypes = () => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(GETMASTERTYPES, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_MASTER_TYPES,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch({
        payload: [],
        type: SET_MASTER_TYPES,
      });
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllTransactionalDataTypes = () => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(GETTRANSACTIOANALTYPES, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_TRANSACTIONAL_DATA_TYPES,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch({
        payload: [],
        type: SET_TRANSACTIONAL_DATA_TYPES,
      });
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllTypes = () => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(GETALLTYPES, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_TYPES,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch({
        payload: [],
        type: SET_ALL_TYPES,
      });
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const generateCaptcha = () => {
  return async (dispatch) => {
    try {
      let response = await API.post(OTPS, {
        type: "captcha",
      });

      if (response && response.data) {
        let captchaId = response.data.id;
        dispatch({
          payload: captchaId,
          type: SET_CAPTCHA_IMAGE,
        });
      }
    } catch (error) {
      dispatch({
        payload: 0,
        type: SET_CAPTCHA_IMAGE,
      });
      // toastr.error(label.Error_while_generating, error.message);
      handleError(error);
    }
  };
};

export const logout = (props, flgRefreshRequired = true) => {
  return async (dispatch) => {
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let userId = session.userId;
      let token = session.jwtResponse && session.jwtResponse.token;
      const logoutResponse = await API.patch(
        `${LOGOUT}/${userId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (logoutResponse.data) {
        sessionStorage.clear();
        props.history.push("/admin/login");
        if (flgRefreshRequired) {
          window.location.reload();
        }
        dispatch({
          type: LOGOUT_CLEAR_USER_SESSION,
        });
      } else {
        toastr.error(label.Logout_failed);
      }
    } catch (error) {
      // let errorMessage =
      //   error.response && error.response.data
      //     ? error.response.data.message
      //     : error.message;
      // toastr.error(label.Logout_failed_colon, errorMessage);
      handleError(error);
    }
  };
};

export const generateOTPForgotPassword = (otpDetails) => {
  return async (dispatch) => {
    try {
      let request;
      switch (otpDetails.type) {
        case "email":
          if (otpDetails.email === "") {
            toastr.info(label.Enter_valid_Email_Id);
            return;
          }
          request = {
            email: otpDetails.email,
            mobile: "",
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
            sendOtpTo: label.email,
            sendOtpDifferent: false,
          };
          break;
        case "mobile":
          if (otpDetails.mobile === "") {
            toastr.info(label.Enter_valid_Mobile_Number);
            return;
          }
          request = {
            email: "",
            mobile: otpDetails.mobile,
            type: otpDetails.type,
            otpFor: otpDetails.otpFor,
            sendOtpTo: label.mobile,
            sendOtpDifferent: false,
          };
          break;
        default:
          toastr.info(label.Error_while_generating_OTP);
          return;
      }
      let response = await API.post(ADMINOTPS, request);
      let emailOTPResponse;
      let mobileOTPResponse;
      if (response && response.data) {
        switch (response.data[0].type) {
          case "email":
            emailOTPResponse = {
              id: response.data[0].id,
              type: response.data[0].type,
            };
            dispatch({
              payload: emailOTPResponse,
              type: SET_GET_EMAIL_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_TIMER_EMAIL,
            });
            if (otpDetails.isForgotPassword) {
              mobileOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: mobileOTPResponse,
                type: SET_GET_MOBILE_OTP_RESPONSE,
              });
            }
            toastr.success(label.OTP_sent_to_registered_email);
            break;
          case "mobile":
            mobileOTPResponse = {
              id: response.data[0].id,
              type: response.data[0].type,
            };
            dispatch({
              payload: mobileOTPResponse,
              type: SET_GET_MOBILE_OTP_RESPONSE,
            });
            dispatch({
              payload: response.data,
              type: GET_OTP_TIMER_MOBILE,
            });
            if (otpDetails.isForgotPassword) {
              emailOTPResponse = {
                id: "",
                type: "",
              };
              dispatch({
                payload: emailOTPResponse,
                type: SET_GET_EMAIL_OTP_RESPONSE,
              });
            }
            toastr.success(label.OTP_sent_to_registered_mobile);
            break;
          default:
            toastr.info(label.Error_while_generating_OTP);
            return;
        }
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
        dispatch({
          payload: false,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
    } catch (error) {
      // let errorMessage =
      //   error.response && error.response.data
      //     ? error.response.data.message
      //     : error.message;
      // toastr.error(label.Get_OTP_Error, errorMessage);
      handleError(error);
    }
  };
};
export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const verificationOfOTP = (reqBody, screen) => {
  return async (dispatch) => {
    try {
      let response = await API.post(VERIFYOTP, reqBody);
      if (response.data) {
        toastr.success(label.OTP_verification_successful);
      } else {
        toastr.error(label.OTP_verification_unsuccessful);
      }
      if (screen === "login") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_LOGIN,
        });
      }
      if (screen === "forgotPassword") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
        });
      }
      if (screen === "registration-email") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
        });
      }
      if (screen === "registration-mobileNumber") {
        dispatch({
          payload: response.data,
          type: SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const enableOTPButton = (screen) => {
  return (dispatch) => {
    if (screen === "login") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_LOGIN,
      });
    }
    if (screen === "forgotPassword") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD,
      });
    }
    if (screen === "registration-email") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL,
      });
    }
    if (screen === "registration-mobileNumber") {
      dispatch({
        payload: false,
        type: SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE,
      });
    }
  };
};

export const getAllAdvertisements = () => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GETADVERTISEMENT, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_ADVERTISEMENTS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

/**** User Access Page */
export const getUserRoles = () => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GET_ALL_USER_ROLES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_USER_ROLES,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getUserRolesByDept = (deptId, roleId, funId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_USER_DEPT_ROLES}/${deptId}/${roleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        let responseData = response.data.users;
        if (funId === 0) {
          dispatch({
            payload: responseData,
            type: SET_USER_DEPT_ROLES,
          });
        } else {
          dispatch({
            payload: responseData,
            type: SET_USER_DEPT_ROLES_FROM,
          });
        }
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      if (funId === 0) {
        dispatch({
          payload: [],
          type: SET_USER_DEPT_ROLES,
        });
      } else {
        dispatch({
          payload: [],
          type: SET_USER_DEPT_ROLES_FROM,
        });
      }
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllModules = () => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GET_ALL_MODULES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_MODULES,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getUsersByRoleIdFrom = (roleId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_ALL_USERS_BY_ROLE_ID}/${roleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_USERS_BY_ROLE_ID_FROM,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getUsersByRoleIdTo = (roleId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_ALL_USERS_BY_ROLE_ID}/${roleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_USERS_BY_ROLE_ID_TO,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getSubModulesByModuleId = (moduleId, userId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_SUB_MODULES_BY_MODULE_ID}/${moduleId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        let responseData = response.data.subModule;
        dispatch({
          payload: responseData,
          type: SET_ALL_SUB_MODULES_BY_MODULE_ID,
        });

        if (response.data.length > 0) {
          dispatch(getAssignedSubModulesByUserModuleId(userId, moduleId));
        } else {
          // toastr.info(label.No_SubModule_Found);
          handleResponseMessage(response);
        }
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const getAssignedSubModulesByUserModuleId = (userId, moduleId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ASSIGN_SUB_MODULES_BY_USER_MODULE_ID}/${userId}/${moduleId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ASSIGN_SUBMODULES_BY_USER_MODULE_ID,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const manageUserAccess = (data, assignUserId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.post(`${MANAGE_ACCESS_TO_USER}/${assignUserId}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        toastr.success(label.SuccessfullySave);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAdvertisementlistByYear = (year) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETADVERTISEMENTBYEAR}?year=${year}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        let responseData = response.data.advertisements;
        dispatch({
          payload: responseData,
          type: SET_YEAR_BY_ID,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getMainsAdvertisements = (year) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETADVERTISEMENTBYEAR}?year=${year}&type=mains`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        let responseData = response.data.advertisements;
        dispatch({
          payload: responseData,
          type: SET_MAINS_ADVERTISEMENT,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getPreAdvertisements = (year) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETADVERTISEMENTBYEAR}?year=${year}&type=pre`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        let responseData = response.data.advertisements;
        dispatch({
          payload: responseData,
          type: SET_PRE_ADVERTISEMENT,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getYearList = (year) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETYEARLIST}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_YEAR,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAlphabeticalList = (setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_ALPHABETICAL_LIST}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALPHABETICAL_LIST,
        });
        handleResponseMessage(response);
        // if (response.data.message !== "No records found") {
        //   setPrintFlag(false)
        // }
        // toastr.error(response.data.message)
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const downloadSampleCSVFile = (type) => {
  return async () => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(DOWNLOAD_SAMPLE_FILE + `?type=${type}`,
        {
          headers: { 'Authorization': `Bearer ${token}` },
        }
      );
    } catch (error) {
      // let errorMessage = (error.response && error.response.data) ?
      //   JSON.parse(await error.response.data.text()).message : error.message
      // // toastr.error(errorMessage);
      // return;
      handleError(error);
    }

    FileDownload(response.data, `${type}.csv`);
  }
};

export const getFlagAccessStatus = (accessUserId, setFlgAccessStatus) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(`${FLAG_ACCESS_STATUS}/${accessUserId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        setFlgAccessStatus(response.data);
        dispatch({
          payload: response.data,
          type: GET_FLAG_ACCESS_STATUS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      // if (error && error.response) {
      //   let errorMessage =
      //     error && error.response && error.response.data
      //       ? error.response.data.message
      //       : label.ErrorWhileSave;
      //   toastr.error(errorMessage);
      //   return;
      // }
      handleError(error);
    }
  };
};

export const getqualificationType = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(`${GET_QUALIFICATION_TYPE}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_QUALIFICATIONTYPE,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      // if (error && error.response) {
      //   let errorMessage =
      //     error && error.response && error.response.data
      //       ? error.response.data.message
      //       : label.ErrorWhileSave;
      //   toastr.error(errorMessage);
      //   return;
      // }
      handleError(error);
    }
  };
};

export const getqualificationNamebytype = (qualificationtype) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${GET_QUALIFICATION_NAME_BY_TYPE}?qualificationtypecode=${qualificationtype}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {

        dispatch({
          payload: response.data,
          type: GET_QUALIFICATION_NAME_BYTYPE,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      // if (error && error.response) {
      //   let errorMessage =
      //     error && error.response && error.response.data
      //       ? error.response.data.message
      //       : label.ErrorWhileSave;
      //   toastr.error(errorMessage);
      //   return;
      // }
      handleError(error);
    }
  };
};

export const getexperience = (type) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${GET_EXPERIENCE}?module=profile_creation&type=${type}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (type == "designation") {
        if (response) {
          dispatch({
            payload: response.data,
            type: GET_DESIGNATION,
          });
        }
      } else if (type == "job_nature") {
        if (response) {

          dispatch({
            payload: response.data,
            type: GET_JOB_NATURE,
          });
        }
      } else if (type == "appointment_nature") {
        if (response) {

          dispatch({
            payload: response.data,
            type: GET_APPOINTMENT_NATURE,
          });
        }
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      // if (error && error.response) {
      //   let errorMessage =
      //     error && error.response && error.response.data
      //       ? error.response.data.message
      //       : label.ErrorWhileSave;
      //   toastr.error(errorMessage);
      //   return;
      // }
      handleError(error);
    }
  };
};

export const interviewCriteria = (selectedExam, data, setSave) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.post(`${SET_INTERVIEW_RECOMMENDATION}?examid=${selectedExam}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        toastr.success(response.data.message);
        setSave(true);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const recommendationCriteria = (selectedExam, data, setSave) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.post(`${SET_RECOMMENDATION_CRITERIA}?examid=${selectedExam}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {

        toastr.success(response.data.message);
        setSave(true)
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getInterviewCriteriaDataView = (examid, setShowOptions) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${GET_INTERVIEW_CRITERIA_DATA}?examid=${examid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_INTERVIEW_CRITERIA_DATA_VIEW,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : label.ErrorWhileSave;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};

export const getRecommendationCriteriaDataView = (examid, setShowOptions) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${GET_RECOMMENDATION_CRITERIA_DATA}?examid=${examid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_RECOMMENDATION_CRITERIA_DATA_VIEW,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : label.ErrorWhileSave;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};



export const setUpdateInterviewCriteria = (data, selectedExam) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.patch(`${SET_UPDATE_INTERVIEW_CRITERIA}?examid=${selectedExam}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {

        toastr.success(response.data.message);
        // dispatch(printrecommendationReport(selectedExam));
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};


export const setUpdateRecommendationCriteria = (data, selectedExam) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.patch(`${SET_UPDATE_RECOMMENDATION_CRITERIA}?examid=${selectedExam}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {

        toastr.success(response.data.message);
        // dispatch(printrecommendationReport(selectedExam));
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : error.message;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};


export const getModuleSubModule = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${GET_MODULE_SUBMODULE}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data.moduleDtos,
          type: SET_MODULE_SUBMODULE,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      if (error && error.response) {
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : label.ErrorWhileSave;
        toastr.error(errorMessage);
        return;
      }
    }
  };
};

export const getUserUpdateDataId = (userId) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_USER_UPDATE_ID}/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_UPDATE_USER_DATA_ID,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getFileUploadStatus = (id) => {
  return async function (dispatch) {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(`${FILE_UPLOAD_STATUS}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_FILE_UPLOAD_STATUS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch({
        payload: {},
        type: SET_FILE_UPLOAD_STATUS,
      });
      dispatch(hideLoader());
      handleError(error);
    }
  };
}


export const downloadErrorCSVFile = (type, id, date) => {
  return async () => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse && session.jwtResponse.token;
    let dateStr = moment(date).format('DD/MM/YYYY HH:mm:ss');
    let response;
    try {
      response = await API.get(`${DOWNLOAD_ERROR_FILE}?errorfilename=${type}&id=${id}`,
        {
          headers: { 'Authorization': `Bearer ${token}` },
        }
      );
    } catch (error) {
      handleError(error);
    }

    if (response.data !== null && response.data !== "") {
      FileDownload(response.data, `${type.charAt(0).toUpperCase() + type.slice(1)} ${dateStr}.csv`);
    }
    else {
      toastr.warning("No records found in error file");
    }
  }
};

export const saveResultFlow = (payload) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    dispatch({ type: SAVE_RESULT_FLOW_REQUEST });
    try {
      const response = await API.post(SAVE_RESULT_FLOW, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      dispatch({
        type: SAVE_RESULT_FLOW_SUCCESS,
        payload: response.data,
      });
      // return response.data;
    } catch (error) {
      dispatch({
        type: SAVE_RESULT_FLOW_FAILURE,
        payload:
          error?.response?.data?.message || "Failed to save result flow",
      });
      // throw error;
    }

  };

};

export const getPostCriteriaByExamId = (examId) => {
  return async function (dispatch) {
    dispatch(showLoader());

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;
    let response;
    try {
      response = await API.get(
        `${SET_POST_LIST}?examId=${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        dispatch({
          type: SET_POST_CRITERIA_LIST,
          payload: response.data,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const fetchSubjectsByExamAndPost = (examId) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;
    let response;
    try {
      const response = await API.get(
        `${FETCH_SUBJECTS_BY_EXAM_AND_POST}?examId=${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data) {
        dispatch({
          type: SET_SUBJECT_LIST_POST,
          payload: response.data,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const getResultFlowInfo = (examId) => {
  return async (dispatch) => {
    if (!examId || isNaN(examId)) {
      console.warn("Invalid examId, skipping getResultFlowInfo");
      return;
    }

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    try {
      const response = await API.get(
        `${GET_SAVE_INFO}/${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: SET_RESULT_FLOW_INFO,
        payload: response.data,
      });
    } catch (error) {
      console.error(
        "GET RESULT FLOW ERROR",
        error?.response?.data || error
      );
    }
  };
};

export const getExamTypeLookup = () => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;
    try {
      const response = await API.get(
        EXAM_TYPE_LOOKUPOPTION,
        {
          params: {
            module: "exam_creation",
            type: "subject_type",
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: SET_LOOKUP_OPTIONS_EXAM_TYPE,
        payload: response.data,
      });
    } catch (error) {
      console.error("Exam Type Lookup Error", error);
    }
  };
};

export const getCheckQualifiedList = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    // try {
    //   const response = await API.get(
    //     `/epms/api/v1/admin/checkqualified/${examId}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    try {
      const response = await API.get(
        `${GET_CHECK_QUALIFIED_LIST}/${examId}/${subjectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: SET_CHECK_QUALIFIED_LIST,
        payload: response.data.candidate || [],
      });

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getFinalResultList = (examId, statusValue) => async (dispatch) => {
  try {
    const response = await API.get(
      GET_FINAL_RESULT_LIST,
      {
        params: {
          examid: examId,
          statusValue: statusValue,
        },
      }
    );

    dispatch({
      type: SET_FINAL_RESULT_LIST,
      payload: response.data,
    });

  } catch (error) {
    console.error("Error fetching final result:", error);

    dispatch({
      type: SET_FINAL_RESULT_LIST,
      payload: {},
    });
  }
};

export const getCutoffSummary = (examId) => async (dispatch) => {
  try {
    const response = await API.get(
      `${GET_CUTOFF_SUMMARY}/${examId}`,
    );

    dispatch({
      type: SET_CUTOFF_SUMMARY,
      payload: response.data.summary || [],
    });

  } catch (error) {
    console.error("Error fetching cutoff summary:", error);

    dispatch({
      type: SET_CUTOFF_SUMMARY,
      payload: [],
    });
  }
};

export const getResultFlowYearList = () => async (dispatch) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const token = session?.jwtResponse?.token;
  try {
    const response = await API.get(
      "/epms/api/v1/admin/advertisements/yearsfromexamflow",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: SET_RESULT_FLOW_YEAR_LIST,
      payload: response.data || [],
    });
  } catch (error) {
    console.error("Error fetching result flow year list:", error);
  }
};

export const getResultFlowAdvertisementList = (year) => async (dispatch) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const token = session?.jwtResponse?.token;

  try {
    const response = await API.get(
      `/epms/api/v1/admin/advertisementsresultflow?year=${year}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: SET_RESULT_FLOW_ADVERTISEMENT_LIST,
      payload: response.data?.advertisements || [],
    });
  } catch (error) {
    console.error("Error fetching advertisement list:", error);
  }
};

export const getExamName = (advtId) => {
  return async (dispatch) => {

    const session = sessionStorage.getItem("session")
      ? JSON.parse(sessionStorage.getItem("session"))
      : "";
    const token = session?.jwtResponse?.token;
    try {
      const response = await API.get(
        `${EXAM_NAME}/${advtId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

      );
      dispatch({
        type: GET_EXAM_NAME,
        payload: response.data
      });

    } catch (error) {
      console.error("GET EXAM NAME ERROR :", error);
    }
  };
};

export const getPostCriteriaList = (examId) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse.token;

    try {
      const response = await API.get(
        `/epms/api/v1/admin/postcriterias/${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: GET_POST_CRITERIA_LIST,
        payload: response.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
};






